export const cityZipCodes = {
    // 台北市
    '台北市中正區': '100',
    '台北市大同區': '103',
    '台北市中山區': '104',
    '台北市松山區': '105',
    '台北市大安區': '106',
    '台北市萬華區': '108',
    '台北市信義區': '110',
    '台北市士林區': '111',
    '台北市北投區': '112',
    '台北市內湖區': '114',
    '台北市南港區': '115',
    '台北市文山區': '116',
    // 基隆市
    '基隆市仁愛區': '200',
    '基隆市信義區': '201',
    '基隆市中正區': '202',
    '基隆市中山區': '203',
    '基隆市安樂區': '204',
    '基隆市暖暖區': '205',
    '基隆市七堵區': '206',
    // 新北市
    '新北市萬里區': '207',
    '新北市金山區': '208',
    '新北市板橋區': '220',
    '新北市汐止區': '221',
    '新北市深坑區': '222',
    '新北市石碇區': '223',
    '新北市瑞芳區': '224',
    '新北市平溪區': '226',
    '新北市雙溪區': '227',
    '新北市貢寮區': '228',
    '新北市新店區': '231',
    '新北市坪林區': '232',
    '新北市烏來區': '233',
    '新北市永和區': '234',
    '新北市中和區': '235',
    '新北市土城區': '236',
    '新北市三峽區': '237',
    '新北市樹林區': '238',
    '新北市鶯歌區': '239',
    '新北市三重區': '241',
    '新北市新莊區': '242',
    '新北市泰山區': '243',
    '新北市林口區': '244',
    '新北市蘆洲區': '247',
    '新北市五股區': '248',
    '新北市八里區': '249',
    '新北市淡水區': '251',
    '新北市三芝區': '252',
    '新北市石門區': '253',
    // 宜蘭縣
    '宜蘭縣宜蘭': '260',
    '宜蘭縣頭城': '261',
    '宜蘭縣礁溪': '262',
    '宜蘭縣壯圍': '263',
    '宜蘭縣員山': '264',
    '宜蘭縣羅東': '265',
    '宜蘭縣三星': '266',
    '宜蘭縣大同': '267',
    '宜蘭縣五結': '268',
    '宜蘭縣冬山': '269',
    '宜蘭縣蘇澳': '270',
    '宜蘭縣南澳': '272',
    '宜蘭縣釣魚臺列嶼': '290',
    // 新竹市
    '新竹市': '300',
    // 新竹縣
    '新竹縣竹北': '302',
    '新竹縣湖口': '303',
    '新竹縣新豐': '304',
    '新竹縣新埔': '305',
    '新竹縣關西': '306',
    '新竹縣芎林': '307',
    '新竹縣寶山': '308',
    '新竹縣竹東': '310',
    '新竹縣五峰': '311',
    '新竹縣橫山': '312',
    '新竹縣尖石': '313',
    '新竹縣北埔': '314',
    '新竹縣峨眉': '315',
    // 桃園市
    '桃園市中壢區': '320',
    '桃園市平鎮區': '324',
    '桃園市龍潭區': '325',
    '桃園市楊梅區': '326',
    '桃園市新屋區': '327',
    '桃園市觀音區': '328',
    '桃園市桃園區': '330',
    '桃園市龜山區': '333',
    '桃園市八德區': '334',
    '桃園市大溪區': '335',
    '桃園市復興區': '336',
    '桃園市大園區': '337',
    '桃園市蘆竹區': '338',
    // 苗栗縣
    '苗栗縣竹南': '350',
    '苗栗縣頭份': '351',
    '苗栗縣三灣': '352',
    '苗栗縣南庄': '353',
    '苗栗縣獅潭': '354',
    '苗栗縣後龍': '356',
    '苗栗縣通霄': '357',
    '苗栗縣苑裡': '358',
    '苗栗縣苗栗': '360',
    '苗栗縣造橋': '361',
    '苗栗縣頭屋': '362',
    '苗栗縣公館': '363',
    '苗栗縣大湖': '364',
    '苗栗縣泰安': '365',
    '苗栗縣銅鑼': '366',
    '苗栗縣三義': '367',
    '苗栗縣西湖': '368',
    '苗栗縣卓蘭': '369',
    // 臺中市
    '台中市中區': '400',
    '台中市東區': '401',
    '台中市南區': '402',
    '台中市西區': '403',
    '台中市北區': '404',
    '台中市北屯區': '406',
    '台中市西屯區': '407',
    '台中市南屯區': '408',
    '台中市太平區': '411',
    '台中市大里區': '412',
    '台中市霧峰區': '413',
    '台中市烏日區': '414',
    '台中市豐原區': '420',
    '台中市后里區': '421',
    '台中市石岡區': '422',
    '台中市東勢區': '423',
    '台中市和平區': '424',
    '台中市新社區': '426',
    '台中市潭子區': '427',
    '台中市大雅區': '428',
    '台中市神岡區': '429',
    '台中市大肚區': '432',
    '台中市沙鹿區': '433',
    '台中市龍井區': '434',
    '台中市梧棲區': '435',
    '台中市清水區': '436',
    '台中市大甲區': '437',
    '台中市外埔區': '438',
    '台中市大安區': '439',
    // 彰化縣
    '彰化縣彰化': '500',
    '彰化縣芬園': '502',
    '彰化縣花壇': '503',
    '彰化縣秀水': '504',
    '彰化縣鹿港': '505',
    '彰化縣福興': '506',
    '彰化縣線西': '507',
    '彰化縣和美': '508',
    '彰化縣伸港': '509',
    '彰化縣員林': '510',
    '彰化縣社頭': '511',
    '彰化縣永靖': '512',
    '彰化縣埔心': '513',
    '彰化縣溪湖': '514',
    '彰化縣大村': '515',
    '彰化縣埔鹽': '516',
    '彰化縣田中': '520',
    '彰化縣北斗': '521',
    '彰化縣田尾': '522',
    '彰化縣埤頭': '523',
    '彰化縣溪州': '524',
    '彰化縣竹塘': '525',
    '彰化縣二林': '526',
    '彰化縣大城': '527',
    '彰化縣芳苑': '528',
    '彰化縣二水': '530',
    // 南投縣
    '南投縣南投': '540',
    '南投縣中寮': '541',
    '南投縣草屯': '542',
    '南投縣國姓': '544',
    '南投縣埔里': '545',
    '南投縣仁愛': '546',
    '南投縣名間': '551',
    '南投縣集集': '552',
    '南投縣水里': '553',
    '南投縣魚池': '555',
    '南投縣信義': '556',
    '南投縣竹山': '557',
    '南投縣鹿谷': '558',
    // 嘉義市
    '嘉義市': '600',
    // 嘉義縣
    '嘉義縣番路': '602',
    '嘉義縣梅山': '603',
    '嘉義縣竹崎': '604',
    '嘉義縣阿里山': '605',
    '嘉義縣中埔': '606',
    '嘉義縣大埔': '607',
    '嘉義縣水上': '608',
    '嘉義縣鹿草': '611',
    '嘉義縣太保': '612',
    '嘉義縣朴子': '613',
    '嘉義縣東石': '614',
    '嘉義縣六腳': '615',
    '嘉義縣新港': '616',
    '嘉義縣民雄': '621',
    '嘉義縣大林': '622',
    '嘉義縣溪口': '623',
    '嘉義縣義竹': '624',
    '嘉義縣布袋': '625',
    // 雲林縣
    '雲林縣斗南': '630',
    '雲林縣大埤': '631',
    '雲林縣虎尾': '632',
    '雲林縣土庫': '633',
    '雲林縣褒忠': '634',
    '雲林縣東勢': '635',
    '雲林縣臺西': '636',
    '雲林縣崙背': '637',
    '雲林縣麥寮': '638',
    '雲林縣斗六': '640',
    '雲林縣林內': '643',
    '雲林縣古坑': '646',
    '雲林縣莿桐': '647',
    '雲林縣西螺': '648',
    '雲林縣二崙': '649',
    '雲林縣北港': '651',
    '雲林縣水林': '652',
    '雲林縣口湖': '653',
    '雲林縣四湖': '654',
    '雲林縣元長': '655',
    // 臺南市
    '台南市中西區': '700',
    '台南市東區': '701',
    '台南市南區': '702',
    '台南市北區': '704',
    '台南市安平區': '708',
    '台南市安南區': '709',
    '台南市永康區': '710',
    '台南市歸仁區': '711',
    '台南市新化區': '712',
    '台南市左鎮區': '713',
    '台南市玉井區': '714',
    '台南市楠西區': '715',
    '台南市南化區': '716',
    '台南市仁德區': '717',
    '台南市關廟區': '718',
    '台南市龍崎區': '719',
    '台南市官田區': '720',
    '台南市麻豆區': '721',
    '台南市佳里區': '722',
    '台南市西港區': '723',
    '台南市七股區': '724',
    '台南市將軍區': '725',
    '台南市學甲區': '726',
    '台南市北門區': '727',
    '台南市新營區': '730',
    '台南市後壁區': '731',
    '台南市白河區': '732',
    '台南市東山區': '733',
    '台南市六甲區': '734',
    '台南市下營區': '735',
    '台南市柳營區': '736',
    '台南市鹽水區': '737',
    '台南市善化區': '741',
    '台南市大內區': '742',
    '台南市山上區': '743',
    '台南市新市區': '744',
    '台南市安定區': '745',
    // 高雄市
    '高雄市新興區': '800',
    '高雄市前金區': '801',
    '高雄市苓雅區': '802',
    '高雄市鹽埕區': '803',
    '高雄市鼓山區': '804',
    '高雄市旗津區': '805',
    '高雄市前鎮區': '806',
    '高雄市三民區': '807',
    '高雄市楠梓區': '811',
    '高雄市小港區': '812',
    '高雄市左營區': '813',
    '高雄市仁武區': '814',
    '高雄市大社區': '815',
    '高雄市岡山區': '820',
    '高雄市路竹區': '821',
    '高雄市阿蓮區': '822',
    '高雄市田寮區': '823',
    '高雄市燕巢區': '824',
    '高雄市橋頭區': '825',
    '高雄市梓官區': '826',
    '高雄市彌陀區': '827',
    '高雄市永安區': '828',
    '高雄市湖內區': '829',
    '高雄市鳳山區': '830',
    '高雄市大寮區': '831',
    '高雄市林園區': '832',
    '高雄市鳥松區': '833',
    '高雄市大樹區': '840',
    '高雄市旗山區': '842',
    '高雄市美濃區': '843',
    '高雄市六龜區': '844',
    '高雄市內門區': '845',
    '高雄市杉林區': '846',
    '高雄市甲仙區': '847',
    '高雄市桃源區': '848',
    '高雄市那瑪夏區': '849',
    '高雄市茂林區': '851',
    '高雄市茄萣區': '852',
    // 屏東縣
    '屏東縣屏東': '900',
    '屏東縣三地門': '901',
    '屏東縣霧臺': '902',
    '屏東縣瑪家': '903',
    '屏東縣九如': '904',
    '屏東縣里港': '905',
    '屏東縣高樹': '906',
    '屏東縣鹽埔': '907',
    '屏東縣長治': '908',
    '屏東縣麟洛': '909',
    '屏東縣竹田': '911',
    '屏東縣內埔': '912',
    '屏東縣萬丹': '913',
    '屏東縣潮州': '920',
    '屏東縣泰武': '921',
    '屏東縣來義': '922',
    '屏東縣萬巒': '923',
    '屏東縣崁頂': '924',
    '屏東縣新埤': '925',
    '屏東縣南州': '926',
    '屏東縣林邊': '927',
    '屏東縣東港': '928',
    '屏東縣琉球': '929',
    '屏東縣佳冬': '931',
    '屏東縣新園': '932',
    '屏東縣枋寮': '940',
    '屏東縣枋山': '941',
    '屏東縣春日': '942',
    '屏東縣獅子': '943',
    '屏東縣車城': '944',
    '屏東縣牡丹': '945',
    '屏東縣恆春': '946',
    '屏東縣滿州': '947',
    // 臺東縣
    '台東縣台東': '950',
    '台東縣綠島': '951',
    '台東縣蘭嶼': '952',
    '台東縣延平': '953',
    '台東縣卑南': '954',
    '台東縣鹿野': '955',
    '台東縣關山': '956',
    '台東縣海端': '957',
    '台東縣池上': '958',
    '台東縣東河': '959',
    '台東縣成功': '961',
    '台東縣長濱': '962',
    '台東縣太麻里': '963',
    '台東縣金峰': '964',
    '台東縣大武': '965',
    '台東縣達仁': '966',
    // 花蓮縣
    '花蓮縣花蓮': '970',
    '花蓮縣新城': '971',
    '花蓮縣秀林': '972',
    '花蓮縣吉安': '973',
    '花蓮縣壽豐': '974',
    '花蓮縣鳳林': '975',
    '花蓮縣光復': '976',
    '花蓮縣豐濱': '977',
    '花蓮縣瑞穗': '978',
    '花蓮縣萬榮': '979',
    '花蓮縣玉里': '981',
    '花蓮縣卓溪': '982',
    '花蓮縣富里': '983',
    // 澎湖縣
    '澎湖縣馬公': '880',
    '澎湖縣西嶼': '881',
    '澎湖縣望安': '882',
    '澎湖縣七美': '883',
    '澎湖縣白沙': '884',
    '澎湖縣湖西': '885',
    // 金門縣
    '金門縣金沙': '890',
    '金門縣金湖': '891',
    '金門縣金寧': '892',
    '金門縣金城': '893',
    '金門縣烈嶼': '894',
    '金門縣烏坵': '896',
    // 連江縣
    '連江縣南竿': '209',
    '連江縣北竿': '210',
    '連江縣莒光': '211',
    '連江縣東引': '212',
    // 南海諸島
    '南海諸島東沙': '817',
    '南海諸島南沙': '819',
};
//# sourceMappingURL=cityZipcodes.js.map